import React from 'react';
import { Heart } from 'lucide-react';

const Profile = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Heart className="h-16 w-16 text-primary mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Health Profile
          </h1>
          <p className="text-lg text-gray-600">
            Profile management coming soon...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
